// extracted by mini-css-extract-plugin
export default {"row":"BankForm_row__uzQD7","rowAlignTop":"BankForm_rowAlignTop__6Es-Y","placeHolderShimmer":"BankForm_placeHolderShimmer__C2R22"};